export const formatFlashcardForClipboard = (flashcard) => {
  const question = flashcard?.chapter || "";
  const answer = flashcard?.body || "";

  return `Q: ${question}\nA: ${answer}`;
};

export const copyTextToClipboard = async (text) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.className = "clipboard-copy-fallback";
  textarea.setAttribute("readonly", "");
  document.body.appendChild(textarea);
  textarea.select();

  const copied = document.execCommand("copy");
  document.body.removeChild(textarea);

  if (!copied) {
    throw new Error("Clipboard copy failed");
  }
};
